// MyWalletTransfer.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faFileAlt } from '@fortawesome/free-solid-svg-icons';


const WalletShared = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(authState.user._id);
  const [payerCode, setPayerCode] = useState(authState.user.think5whyscode);

  const [payerName, setPayerName] = useState(authState.user.name);
  const [payeeId, setPayeeId] = useState('');
  const [payeeCode, setPayeeCode] = useState('');
  const [payeeName, setPayeeName] = useState('');
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] =  useState(0);
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [transactionId, setTransactionId] = useState('123456789');
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [error, setError] = useState(null);
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
  const [walletBalancePoints, setWalletBalancePoints] = useState(0);
  const [walletLastUpdated, setWalletLastUpdated] = useState();
  const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
  const [payeeCodeStatus, setPayeeCodeStatus] = useState(false);
  const [payeeCodeStatusMsg, setPayeeCodeStatusMsg] = useState('');
  const [payeeCodeButtonClicked, setPayeeCodeButtonClicked] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [authorisedOTP, setAuthorisedOTP] = useState(false);

//WalletBalance
const fetchWalletBalance = useCallback(() => {
  const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Wallet Balance Response:", response);
          if (response) {
              setWalletBalanceAmount(response.balanceAmount);
              setWalletBalancePoints(response.balancePoints);
              setWalletLastUpdated(response.lastTransactionDate);
              setWalletLastUpdatedRemarks(response.remarks);
          } else {
              console.error("Invalid response format: Wallet not found in response");
              setWalletBalanceAmount(0);
              setWalletBalancePoints(0);
              setWalletLastUpdated(null);
              setWalletLastUpdatedRemarks('');
          }
      })
      .catch(error => {
          console.error("Error fetching wallet master:", error);
          setWalletBalanceAmount(0);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
  }, [authState.isLoggedIn, fetchWalletBalance]);

  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    sharedCode: "",
    sharedName: "",
    shareType: "",
    amount: "",
    remarks: "",
    signatory: "",
    isAgree: false,
    sharedWalletName: 'Jahan Char Yaar Mil Jaye!!'
  });

  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  
  const payeeCodeValidationClicked = () => {
    // console.log("payeeCodeValidationClicked", formData);

    setPayeeCodeButtonClicked(true);
    
    // Validate Payee Code
    if (/^TU[a-zA-Z0-9]{12}$/.test(formData.payeeCode)) {
        // fetchPayeeCode(formData.payeeCode);
        // Validate Amount
        if (formData.amount <= 0 || !/^[0-9]+(\.[0-9]{1,2})?$/.test(formData.amount)) {
            setError("Error in Amount Input");
            return;
        }
        
        // Check Wallet Balance
        if (formData.amount > walletBalanceAmount) {
            setError("Your Wallet Balance has insufficient funds to make the transfer. Please recharge your Wallet.");
            return;
        }  

        if (formData.remarks=='') {
          setError("Transfer Remarks is required!!");
          return;
        }

        // Check for Self Transfer
        if (formData.payeeCode === payerCode) {
            setError(`Your Code is ${payerCode} and Payee Code is ${formData.payeeCode}. Self Transfer is not allowed!`);
            return;
          } 
          fetchPayeeCode(formData.payeeCode);
    } else {
        setError('Please enter a valid 14-character Think5Whys user code starting with TU.');
    }
};


const fetchPayeeCode = useCallback((payeeCode) => {
  // console.log("payeeCode for API call ", payeeCode);
  const config = {
      url: "/auth/verifyreferralcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: payeeCode }
  };

  fetchData(config)
      .then(response => {
        // console.log("API Response: ", response); 
          if (response && response.status) {
              // console.log("fetchPayeeCode found ", response);
              setPayeeCodeStatus(true);
              setPayeeId(response.t5wcode._id);
              setPayeeName(response.t5wcode.name);
              setPayeeCodeStatusMsg("Payee Code found. 😊");
              // console.log("Payee Code found");
          } else {
              // console.log("Payee Code Not found");
              setPayeeCodeStatus(false);
              setPayeeCodeStatusMsg(`Payee Code ${payeeCode} not found! 😔 Make sure the Payee Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("Payee Code Not found!", error);
          setPayeeCodeStatus(false);
          setPayeeCodeStatusMsg("Error in getting data");
      });
}, [fetchData, authState.token]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchPayeeCode]);

  const handleAddPayeeButtonClick = () => {
    setPaymentClicked(true);
    saveWalletTransaction();
  };

  const saveWalletTransaction = async () => {
    const requestData = {
      payerName: payerName,
      payerId: userId,
      payeeId: payeeId,
      dateTransaction: new Date(),
      particulars: "Wallet Transfer to "+payeeName+" by "+payerName,
      amount: formData.amount,
      currency: "Credits",
      inOut: 2,  //Transfer (Out)
      points: 0,
      wallet: "User Wallet",
      remarks: formData.remarks,
      modePayment: '"Think5Whys Wallet Transfer"',
      transactionId: 'D' + Date.now(),
      transactionDate: Date.now(),
      transactionStatus: 'Success',
      paymentDetails: 'NA',
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
    };
    // console.log('Wallet Transfer data to be saved:', requestData);
    try {
      const config = { 
        url: `/wallet/transfer`, 
        method: "post", 
        data: requestData, 
        headers: { Authorization: authState.token } 
      };
      await fetchData(config);
      setPaymentStatus(true)
      // console.log("After Saving Data", fetchData)
      navigate('/wallet-mywallet');
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Shared Wallet</h2>
      </div>
      <div className="border p-4">
        <div className="wallet-container">
          <div>
            <div className='flex flex-col justify-center text-white'>
              <p className='text-bold text-yellow-200'>Think5Whys Shared Wallet Terms of Use, Policy & Compliance:</p>
              <p>1. You can pool max 10,000.00 in your shared wallet</p>
              <p>2. Every participant must be registered on Think5Whys Platform</p>
              <p>3. Shared wallet can be filled/topups only through Wallet Transfer facility on Think5Whys</p>
              <p>4. Any participant can withdraw the money subject to OTP provided by at least 75% of participants</p>
              <p>5. Money will be transferred to an UPI account</p>
              <p>6. This facility is currently available in India only</p>
              <p>7. This is a convenience facility and is available for genuine & legitimate purpose only</p>
              <p>8. Think5Whys Global IT & AI Solutions may monitor the transactions for any suspicious activities</p>
              <p>9. A Processing, Tchnology & Compliance fee @7% + GST will be charged at the time of withdrawal</p>
              <p>10. You outward transaction are subject to our banker's terms & conditions</p>
              <p>11. Company will not liable due to any technology glitches at our banker or any of our partner end</p>
              <p>12. Company can change this terms of use, its policies etc without any prior intimation if its internal to the company</p>
              <p className='text-yellow-200'>Note: Do not use this facility for any emergency purpose</p>
            </div>
            <div className='flex flex-row justify-center'>
              <button
                onClick={handleAddPayeeButtonClick}
                disabled={paymentClicked}
                className='px-4 py-2 bg-orange-500 text-white rounded'
              >
                Shared Wallets List
              </button>
            </div>
            <div className='mt-4 flex justify-center'>
              <p className='text-white'>You have select the Shared Wallet:</p>
              <p className='text-yellow-200 text-xl'>{formData.sharedWalletName}</p>
              <p className='text-white'>Wallet Code: <strong>TX243AM5850150</strong></p>
            </div>
            <div className='mt-4 flex text-wrap justify-center'>
              <p className='text-white'>Your Pooled Wallet Amount is Credits {walletBalanceAmount}</p>
            </div>
            <div className='mt-4 flex justify-center'>
              <select name="shareType" id="shareType" value={formData.shareType}
                onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px', width: '50%' }}>
                <option value="">Select Transaction Type</option>
                <option value="Contribute">Contribute</option>
                <option value="Withdraw">Withdraw</option>
              </select>
            </div>
            {formData.shareType==='Withdraw' && (
              <>
              <div className="flex justify-center">
                  <p className='text-orange-500'>A charges of ₹ {(walletBalanceAmount * 0.0826).toFixed(2) } will be deducted.</p>
              </div>
              <div className="border-container flex justify-center">
                  <input 
                    type="text" 
                    name="authorisationOTP" 
                    id="authorisationOTP" 
                    value={formData.authorisationOTP} 
                    placeholder="Enter Authorisation OTP..."
                    maxLength="100"
                    onChange={handleChange}
                    style={{
                      border: '1px solid #ccc',
                      padding: '2px',
                      width: '50%',
                      height: '50px',
                      boxSizing: 'border-box',
                    }} 
                  />
                  {fieldError("authorisationOTP")}
                  <button
                    onClick={handleAddPayeeButtonClick}
                    disabled={authorisedOTP}
                    className='px-4 py-2 bg-blue-500 text-white rounded w-20'
                  >
                    Validate
                  </button>
                </div>
              </>
            )}
            <div className="mb-4 flex justify-center">
              <input
                type="text"
                name="amount"
                id="amount"
                value={formData.amount}
                placeholder="Input Amount"
                onChange={handleChange}
                className="h-12 text-center p-2 border border-gray-300"
              />
              {fieldError("Amount")}
            </div>
            <div className="mb-4 flex justify-center">
              <input
                type="text"
                name="remarks"
                id="remarks"
                value={formData.remarks}
                placeholder="Input Remarks"
                onChange={handleChange}
                className="h-12 text-center p-2 border border-gray-300"
              />
              {fieldError("Remarks")}
            </div>
            <div className="flex justify-center text-yellow-200">
              <label className='text-yellow-200'>
                <input className='mr-4' type="checkbox" checked={formData.isAgree} onChange={(e) => setFormData({ ...formData, isAgree: e.target.checked })} />
                I Agree to the Terms & Conditions, Policies & Compliances 
              </label>
            </div>
            <div className='flex justify-center'>
              <button
                onClick={handleAddPayeeButtonClick}
                disabled={paymentClicked}
                className='px-4 py-2 bg-orange-500 text-white rounded'
              >
                Confirm Transfer Amount {parseFloat(formData.amount).toFixed(2)} to {formData.sharedWalletName} Think5Whys Shared Wallet
              </button>
            </div>
            {error && (
              <div className="mb-4 flex justify-center">
                <p className="text-red-500 text-lg">{error}</p>
              </div>
            )}
            <div className="flex justify-center">
              <p className={payeeCodeStatus ? "text-green-500" : "text-red-600"}>
                <strong className='text-xl'>{payeeCodeStatusMsg}</strong>
              </p>
            </div>
            {payeeCodeStatus && (
              <>
                <div className="flex justify-center">
                  <p className="text-white text-lg">Your Payee Name: <strong className="text-yellow-300 text-lg">{formData.sharedWalletName}</strong></p>
                </div>
                <div className='flex justify-center'>
                  <button
                    onClick={handleAddPayeeButtonClick}
                    disabled={paymentClicked}
                    className='px-4 py-2 bg-orange-500 text-white rounded'
                  >
                    Confirm Transfer Amount {parseFloat(formData.amount).toFixed(2)} to {formData.sharedWalletName} Think5Whys Shared Wallet
                  </button>
                </div>
                {paymentClicked && (
                  <div className='flex justify-center'>
                    {paymentStatus ? (
                      <p className='text-green-800'>Transferred an Amount of Credits {parseFloat(formData.amount).toFixed(2)} to {formData.sharedWalletName} Think5Whys Wallet</p>
                    ) : (
                      <p className='text-red-600'>Think5Whys Wallet Transfer of an Amount of Credits {parseFloat(formData.amount).toFixed(2)} to {formData.sharedWalletName} Failed. Please retry.</p>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default WalletShared;
